import React from "react";
import ReactDOM from "react-dom";
import { ApolloProvider } from "react-apollo";
import GraphqlRecentlyViewed from "./components/recently-viewed/graphql-recently-viewed";
import { renderReact } from "hypernova-react";
import BurgerMenu from "./components/burger-menu/burger-menu";
import ImageGallery from "./components/image-gallery/image-gallery";
import { client } from "./lyst-apollo-client";
import VentoryMenu from "./components/ventory-menu/ventory-menu";

// HOC to wrap a component if it needs to use the apollo client

function ApolloComponent(AppComponent, props) {
    return (
        <ApolloProvider client={client}>
            <AppComponent {...props} />
        </ApolloProvider>
    );
}

export function initialiseReact() {
    const domNodeToReplace = document.getElementById("lyst-react-recently-viewed");

    if (domNodeToReplace) {
        const currentProductId = domNodeToReplace.dataset.currentProductId;
        ReactDOM.render(
            ApolloComponent(GraphqlRecentlyViewed, { currentProductId }),
            domNodeToReplace
        );
    }

    renderReact("BurgerMenu.jsx", BurgerMenu);
    renderReact("VentoryMenu.jsx", VentoryMenu);
    renderReact("ImageGallery.jsx", ImageGallery);
}
